export default "__VITE_ASSET__DwH6tCOZ__"